/* eslint-disable no-lonely-if */
import { connect } from 'react-redux'
import { CognitoUserPool } from 'amazon-cognito-identity-js'
import PropTypes from 'prop-types'
import AWS from 'aws-sdk/global'
import React from 'react'
import settings from 'settings'
import { Link, withRouter } from 'react-router-dom'
import queryString from 'query-string'
import Cookie from 'universal-cookie'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

// Components
import Nav from 'app/views/components/Nav'

// Containers
import ScrollToTop from 'app/views/containers/ScrollToTop'

// Redux
import { initialize, login } from 'app/state/modules/auth'

// Utils
import {
  getEmailFromJWT,
  getUsernameFromJWT,
  logout,
} from 'app/views/utils/auth'

import {
  getOrganizations,
} from 'app/state/modules/hacker'

// Other
import Routes from 'app/views/routes'
import { api } from 'app/views/utils/api'

const propTypes = {
  onInitialize: PropTypes.func.isRequired, // mapDispatchToProps
  onLogin: PropTypes.func.isRequired, // mapDispatchToProps
}

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      showCookieNotice: null,
    }
  }

  componentDidMount() {
    api({
      method: 'GET',
      url: `${settings.urls.hacker}/params`,
    })
      .then(({ data }) => {
        
        settings.plans = data.plans
        settings.apps = data.assessment_apps.reduce((prev, curr) => {
          prev[curr.key] = curr.name
          return prev
        }, {})
        settings.appsDescriptions = data.assessment_apps.reduce((prev, curr) => {
          prev[curr.key] = curr.description
          return prev
        }, {})

        settings.integrations = data.integrations.reduce((prev, curr) => {
          prev[curr.key] = curr
          return prev
        }, {})
        settings.owasp = data.owasp
        settings.availableLanguages = data.languages
        settings.translationLanguages = data.translationLanguages
        
      })
      .catch((err) => {
        console.error(err)
      })
    if (this.props.location.pathname !== '/auth') {
      const clientId = localStorage.getItem('hackedu.cognito.clientId')
      let poolData = null
      if (clientId === '1p6bb22tops0hjelbk500j5son') {
        poolData = {
          UserPoolId: settings.cognito.authDataHackEDU.UserPoolId,
          ClientId: settings.cognito.authDataHackEDU.ClientId,
        }
      } else if (clientId === '46m8aq1d3s534d9vuqv8hks801') {
        poolData = {
          UserPoolId: settings.cognito.authDataAllegiant.UserPoolId,
          ClientId: settings.cognito.authDataAllegiant.ClientId,
        }
      } else {
        poolData = {
          UserPoolId: settings.cognito.authData.UserPoolId,
          ClientId: settings.cognito.authData.ClientId,
        }
      }
      const userPool = new CognitoUserPool(poolData)
      const user = userPool.getCurrentUser()

      if (user !== null) {
        user.getSession((err, session) => {
          if (err) {
            this.props.onInitialize(false, '')
            this.setState({ loading: false })
          } else {
            if (this.props.location.pathname.indexOf('/login') === 0) {
              localStorage.setItem('hackedu.redirect.login.pathname', this.props.location.pathname)
              localStorage.setItem('hackedu.redirect.login.search', this.props.location.search)
              logout()
            } else {
              user.refreshSession(session.refreshToken, (newError, newSession) => {
                if (newError) {
                  console.error('error with refresh session: ', newError)
                } else {
                  this.props.onLogin(
                    getUsernameFromJWT(newSession.idToken.jwtToken),
                    getEmailFromJWT(newSession.idToken.jwtToken),
                    newSession.accessToken.jwtToken,
                    newSession.idToken.jwtToken,
                  )
                  const cookie = new Cookie()
                  const expires = new Date()
                  expires.setFullYear(expires.getFullYear() + 1)
                  cookie.set('hackedu.logged.in.app', 'true', {
                    path: '/',
                    domain: settings.urls.www.replace(/(https:\/\/www\.|http:\/\/www\.|:.+|http:\/\/)/g, ''),
                    expires,
                  })
                  this.props.onInitialize(true, null)
                  this.setState({ loading: false })
                }
              })
            }
          }
        })
      } else {
        // Set the region where your identity pool exists
        AWS.config.region = settings.aws.region

        // Configure the credentials provider to use your identity pool
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: settings.aws.identityPoolId,
        })

        // Make the call to obtain credentials
        AWS.config.credentials.get(() => {
          this.props.onInitialize(false, AWS.config.credentials.identityId)
          this.setState({ loading: false })
        })
      }
    } else {
      this.props.onInitialize(false, '')
      this.setState({ loading: false })
    }

    const hasSeenCookieNotice = localStorage.getItem('hackedu.hasSeenCookieNotice')
    if (hasSeenCookieNotice === 'true') {
      this.setState({ showCookieNotice: false })
    } else {
      this.setState({ showCookieNotice: true })
    }

    // Set ref
    const { ref } = queryString.parse(this.props.location.search)
    if (ref) {
      localStorage.setItem('hackedu.ref.name', ref)
      localStorage.setItem('hackedu.ref.date', new Date().toISOString().slice(0, 10))
      window.intercomSettings = {
        ref,
      }
    }

    // Segment Script
    const script = document.createElement('script')
    const scriptText = document.createTextNode(`!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error('Segment snippet included twice.');else{analytics.invoked=!0;analytics.methods=['trackSubmit','trackClick','trackLink','trackForm','pageview','identify','reset','group','track','ready','alias','debug','page','once','off','on'];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement('script');e.type='text/javascript';e.async=!0;e.src=('https:'===document.location.protocol?'https://':'http://')+'cdn.segment.com/analytics.js/v1/'+t+'/analytics.min.js';var n=document.getElementsByTagName('script')[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION='4.0.0'; analytics.load('${settings.segment.key}');}}();`)
    script.appendChild(scriptText)
    document.body.appendChild(script)
  }

  componentDidUpdate(prevProps) {
    // Send user info to LaunchDarkly once hacker.profile is initialized
    if (prevProps.profile.user_id !== this.props.profile.user_id) {
      this.props.ldClient.identify({
        key: this.props.profile.user_id,
        email: this.props.profile.email,
        name: this.props.profile.username,
        privateAttributeNames: ['email', 'name'],
      })
    }
  }

  render() {
    if (this.state.loading === true) {
      return (
        <div className="uk-section" style={{ height: '100vh', paddingTop: '50vh' }}>
          <div className="uk-container">
            <div className="uk-text-center">
              <div data-uk-spinner="" />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        <Nav />
        {this.props.children}
        <div
          style={{ minHeight: 'calc(100vh - 466px)' }}
          className={(this.props.isAuthenticated) ? ('app') : ('')}
        >
          <Routes />
        </div>
        {(this.state.showCookieNotice === true) && (
          <div
            className="uk-padding-small uk-background-secondary "
            style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 9999 }}
          >
            <div className="uk-container">
              <div data-uk-grid className="uk-padding-remove-vertical uk-padding-large">
                <div className="uk-width-2-3@m uk-light">
                  This website uses cookies and other technology to customize
                  advertising and provide you a more personalized experience. To
                  find out more, see our
                  &nbsp;
                  <a
                    href={`${settings.urls.www}/privacy`}
                    target="_blank"
                    style={{ textDecoration: 'underline' }}
                  >
                    Privacy Policy
                  </a>
                  .
                </div>
                <div className="uk-width-1-3@m">
                  <button
                    data-test-id="accept-cookies-btn"
                    type="button"
                    className="uk-button uk-button-primary tm-button-primary"
                    onClick={() => {
                      localStorage.setItem('hackedu.hasSeenCookieNotice', 'true')
                      this.setState({ showCookieNotice: false })
                    }}
                  >
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <ScrollToTop />
      </div>
    )
  }
}

App.propTypes = propTypes

const mapStateToProps = (state) => ({
  // auth
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  profile: state.hacker.profile,
})
const mapDispatchToProps = (dispatch) => ({
  onInitialize: (loggedIn, unauthenticatedId) => {
    dispatch(initialize(loggedIn, unauthenticatedId))
  },
  onLogin: (username, email, accessToken, idToken) => {
    dispatch(login(username, email, accessToken, idToken))
  },
  getOrganizations: () => dispatch(getOrganizations()),
})

export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)))
